<div class="card">
	<p-table
		#dt
		[value]="dealerService.dealer.value.venues"
		[loading]="!dealerService.dealer.value.venues"
		[globalFilterFields]="app.keys(dealerService.dealer.value.venues)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
		resizableColumns="true"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th style="flex-basis: 20%">Venue</th>
				<th style="flex-basis: 10%">Link Status</th>
				<th style="flex-basis: 70%">Stations</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td style="flex-basis: 20%" class="overflow-scroll" (click)="venueService.changeVenue.next(rec)">{{ rec.name }} - {{ rec.key }}</td>
				<td style="flex-basis: 10%" (click)="venueSelectedChange.emit(rec)">
					<div *ngIf="rec.status">
						<span *ngIf="app.moment().diff(app.moment(rec.status.connectorHeartbeat), 'minutes') > 10">
							<fa-icon [icon]="['fas', 'circle']" class="red-icon me-1"></fa-icon>
							<span *ngIf="rec.status.connectorHeartbeat">{{ app.moment(rec.status.connectorHeartbeat).fromNow() }}</span>
							<span *ngIf="!rec.status.connectorHeartbeat">never</span>
						</span>
						<span
							*ngIf="
								app.moment().diff(app.moment(rec.status.connectorHeartbeat), 'minutes') < 10 &&
								app.moment().diff(app.moment(rec.status.connectorHeartbeat), 'minutes') > 5
							"
						>
							<fa-icon [icon]="['fas', 'circle']" class="yellow-icon me-1"></fa-icon>
							<span *ngIf="rec.status.connectorHeartbeat">{{ app.moment(rec.status.connectorHeartbeat).fromNow() }}</span>
						</span>
						<span *ngIf="app.moment().diff(app.moment(rec.status.connectorHeartbeat), 'minutes') <= 5">
							<fa-icon [icon]="['fas', 'circle']" class="green-icon"></fa-icon>
						</span>
					</div>
					<div *ngIf="!rec.status">
						<fa-icon [icon]="['fas', 'circle']" class="red-icon me-1"></fa-icon>
						never
					</div>
				</td>
				<td class="station-status" style="flex-basis: 70%" (click)="venueSelectedChange.emit(rec)">
					<div
						*ngFor="let station of rec.status?.stationStatus"
						class="station mx-1"
						pTooltip="{{ station.name }} - {{ app.moment(station.lastPulse).format('l LT') }}"
					>
						<div *ngIf="app.moment().diff(app.moment(station.lastPulse), 'minutes') > 10" class="red-icon">
							<fa-icon
								[icon]="['fas', 'circle']"
								*ngIf="!station.isMobile && !station.isEvent && !station.isCredit && !station.isEmail"
							></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'mobile']" *ngIf="station.isMobile"></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'calendar']" *ngIf="station.isEvent"></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'credit-card']" *ngIf="station.isCredit"></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'envelope']" *ngIf="station.isEmail"></fa-icon>
						</div>
						<div
							*ngIf="
								app.moment().diff(app.moment(station.lastPulse), 'minutes') < 10 &&
								app.moment().diff(app.moment(station.lastPulse), 'minutes') > 5
							"
							class="yellow-icon"
						>
							<fa-icon
								[icon]="['fas', 'circle']"
								*ngIf="!station.isMobile && !station.isEvent && !station.isCredit && !station.isEmail"
							></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'mobile']" *ngIf="station.isMobile"></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'calendar']" *ngIf="station.isEvent"></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'credit-card']" *ngIf="station.isCredit"></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'envelope']" *ngIf="station.isEmail"></fa-icon>
						</div>
						<div *ngIf="app.moment().diff(app.moment(station.lastPulse), 'minutes') <= 5" class="green-icon">
							<fa-icon
								[icon]="['fas', 'circle']"
								*ngIf="!station.isMobile && !station.isEvent && !station.isCredit && !station.isEmail"
							></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'mobile']" *ngIf="station.isMobile"></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'calendar']" *ngIf="station.isEvent"></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'credit-card']" *ngIf="station.isCredit"></fa-icon>
							<fa-icon class="mx-1" [icon]="['far', 'envelope']" *ngIf="station.isEmail"></fa-icon>
						</div>
					</div>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="loadingbody">
			<tr>
				<td colspan="3">
					<div class="h4 text-center">Loading...</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
